const feedbackYes = document.querySelector( '#feedback-button-yes' );
const feedbackNo = document.querySelector( '#feedback-button-no' );

if ( feedbackYes && feedbackNo ) {

  document.querySelector( '#feedback-button-yes' ).addEventListener( 'click', function( event ) {

    event.preventDefault();
    event.stopPropagation();

    document.querySelector( '#input_4_3' ).value = 'Yes';

    document.querySelector( '#gform_wrapper_4' ).classList.remove( 'is-active' );

    document.querySelector( '#feedback-button-yes' ).style.display = 'none';
    document.querySelector( '#feedback-button-no' ).style.display = 'none';
    document.querySelector( '#feedback-spinner-wrapper' ).style.display = 'inline-block';

    document.querySelector( '#gform_4' ).submit();

  } );

  document.querySelector( '#feedback-button-no' ).addEventListener( 'click', function( event ) {

    event.preventDefault();
    event.stopPropagation();

    document.querySelector( '#input_4_3' ).value = 'No';

    document.querySelector( '#gform_wrapper_4' ).classList.add( 'is-active' );

  } );

}

if ( jQuery ) {

  jQuery( document ).on( 'gform_confirmation_loaded', function( event, formId ) {

    if ( formId === 4 ) {

      document.querySelector( '#feedback-heading-buttons-wrapper' ).style.display = 'none';
      document.querySelector( '#feedback-spinner-wrapper' ).style.display = 'none';

    }

  } );

}
